import { createFileRoute } from '@tanstack/react-router'
import { PrivacyPage } from '@/components/pages/privacy-page'

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
  head: () => ({ meta: [{ title: 'Privacy policy — mkdn.app' }] }),
})
